import React, {useCallback} from 'react';
import {useTheme} from '@mui/material';
import {CardProps} from './types';
import {formatAddress} from 'presentation/utils';
import {PredefinedFavoritePlacesEnum} from 'domain/usecases';
import {FavoriteAddressesItem} from '../../types';

export function useCard({handleCardClick, item}: Pick<CardProps, 'handleCardClick' | 'item'>) {
	const {colors} = useTheme();

	const getRightIcon = (description: string) => {
		switch (description) {
			case PredefinedFavoritePlacesEnum.HOUSE:
				return 'home-filled';
			case PredefinedFavoritePlacesEnum.WORK:
				return 'building-outline';
			default:
				return 'location-on-filled';
		}
	};

	const handleCardKeyDown = useCallback(
		(event: React.KeyboardEvent<HTMLElement>, item: FavoriteAddressesItem) => {
			if (event.currentTarget !== event.target) {
				return;
			}

			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault();
				handleCardClick(item);
			}
		},
		[handleCardClick],
	);

	const {nmLogradouro, nuEndereco, dsComplemento, nmBairro, nmCidade, nmUf} = item.address;

	const formattedAddress = formatAddress({
		address: nmLogradouro.replace(/^(\w+)\s/, '$1. '),
		number: `${nuEndereco}`,
		complement: dsComplemento,
		district: nmBairro,
		city: nmCidade,
		state: nmUf,
	});

	return {colors, getRightIcon, handleCardKeyDown, formattedAddress};
}
